'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  empty: 'No results',
  item: function item(data) {
    return JSON.stringify(data, null, 2);
  }
};


// WEBPACK FOOTER //
// ./~/instantsearch.js/dist-es5-module/src/widgets/infinite-hits/defaultTemplates.js